import { get } from '@bigyouth/base'

import withControls from '../hoc/withControls'
import setAttributes from '../utils/setAttributes'
import removeAttributes from '../utils/removeAttributes'
import triggerButton from '../utils/triggerButton'
import { create } from '../utils/sigpipe'
import scrollManager from '../utils/scrollManager'

export const ACTIONS = {
  CLOSE: 'close',
}

export default withControls({
  name: 'modal-control',

  events: [triggerButton('openModal')],

  componentDidMount () {
    if (!this.ui.controls.hidden) {
      this.openModal()
    }
  },

  openModal () {
    if (!this.ui.controls.hidden) return

    this.placeholder = document.createElement('span')
    this.placeholder.hidden = true
    this.ui.controls.parentNode.insertBefore(this.placeholder, this.ui.controls)
    // this.ui.controls.hidden = false
    this.ui.controls.classList.remove('is-hidden')

    const pipe = create().on(action => {
      if (action === ACTIONS.CLOSE) {
        this.closeModal()
        pipe.destroy()
      }
    })

    setAttributes({
      tabindex: -1,
      jsModal: `'${pipe.id}'`,
    })(this.ui.controls)

    get('.modals').appendChild(this.ui.controls)

    setTimeout(function () {
      scrollManager.stop()
    }, 500)
  },

  closeModal () {
    if (this.ui.controls.hidden) return

    removeAttributes('tabindex', 'jsModal')(this.ui.controls)
    this.placeholder.parentNode.insertBefore(this.ui.controls, this.placeholder)
    this.placeholder.remove()
    // this.ui.controls.hidden = true
    this.ui.controls.classList.add('is-hidden')
    this.el.focus({ preventScroll: true })

    scrollManager.restart()
  },
})
